import Api from 'services/Api';

export const loadTrip = ({ id, start }) => {
  return Api.query(
    `query($user_id: String!, $start: [String]!) {
    user(id: $user_id) {
      event_history(start: $start, mode: [car]) {
        start
        end
        start_ts
        end_ts
        ... on Transport {
          distance
          occupant_role
          trajectory {
            waypoints {
              latitude
              longitude
              timestamp
              speed
              speed_limit
              road_type
            }
          }
          behavior_scores {
            ... on CarBehaviorScores {
              overall
              smooth_v2
              legal_v2
              anticipative_v2
              focus
              mounted
            }
          }
          behavior_annotations {
            type
            start
            end
            ... on AccelerationBehaviorAnnotation {
              duration
              acceleration
              magnitude
            }
            ... on AnomalyBehaviorAnnotation {
              anomaly
              duration
            }
            ... on TurnBehaviorAnnotation {
              maneuver
              duration
              magnitude
            }
          }
        }
      }
    }
  }`,
    {
      user_id: id,
      start: [start],
    }
  ).catch(err => err);
};
